/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'
/**
 * Import
 * - Actions
 */
import { setStep04c, setStep04cRenewals, resetQuotes, getRenewalVariation } from '../../../actions'
/**
 * Import
 * - Page component
 */
import Step04c from '../../../components/pages/Quote/Step04c/Step04c'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: (props.editRenewal) ?
            get(state.quote, 'fullRenewals.response.renewal', {}) : get(state.quote, 'full.response.quote', {}),
        isWineSpirits: true,
        isCollectors: false,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep04c: setStep04c,
        setStep04cRenewals: setStep04cRenewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
    }
)(Step04c)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step04w.tsx